/* eslint-disable no-console */
import mapboxgl from "mapbox-gl";
import Chart from "chart.js";
import { filter } from "lodash";
import profileChart from "../util/profileChart";
import chartElevationLabel from "../util/chartElevationLabel";
import chartDistanceLabel from "../util/chartDistanceLabel";
import sortTable from "../util/sortTable";
import ajaxLogin from "../util/ajaxLogin";
import tippy from "tippy.js";
import MicroModal from "micromodal";
import 'slick-carousel';
import Splide from '@splidejs/splide';

function notFirstY(scaleInstance) {
  scaleInstance.ticks[scaleInstance.ticks.length - 1] = "";
}

function notFirstOrLast(scaleInstance) {
  scaleInstance.ticks[scaleInstance.ticks.length - 1] = "";
  scaleInstance.ticks[0] = "";
}

export default {
  init() {
    // JavaScript to be fired on a trip page
    ajaxLogin();

    mapboxgl.accessToken =
      "pk.eyJ1IjoidGhvbXNvbmJpa2V0b3Vyc2hnciIsImEiOiJja2RxajRlbXExNTU4MnNwYWF5bWpxN3phIn0.12ARFSA84qS3RoVS3Zb-sw";

    // Access token for local
    // mapboxgl.accessToken =
    //   "pk.eyJ1IjoiYm1zZGFuIiwiYSI6ImNscDVldWN4YjFtcG0yaXM2Nmw0NHV6a2QifQ.Gs8Gblc-PdxLGI8FKHjOTw"; 

    let dayData = {};
    for (var i = 1; i <= $(".trip-detail-wrap").data("total"); i++) {
      dayData[i] = { loaded: false, empty: true };
    }
    let climbData = {};
    let dayMap = false;
    let tripMap = false;
    let climbMap = [];
    let markers = [];
    let ctx = document.getElementById("trip-day-profile-chart");
    let chart = false;
    //sub-nav
    $(
      ".trip-nav--bottom a, .jump-to-mob-display a, .itinerary-hotel, .day-gravel a, .early-bird, .col-room-upgrades a"
    ).on("click", function (e) {
      let target = $(this).data("target");
      if (target && $(target).length) {
        e.preventDefault();
        let top = 0;
        $(target).each(function () {
          if ($(this).offset().top > 0) {
            top = $(this).offset().top;
          }
        });
        $("html, body").animate(
          {
            scrollTop:
              $(window).width() < 768
                ? top - 220
                : top -
                  ($(".trip-nav").height() +
                    parseInt($(".trip-nav").css("top"), 10) +
                    30),
          },
          500
        );
      }
    });
    if ($(".toggle-rider-level").length) {
      $(".rider-level")
        .not(".active")
        .on("click", function () {
          $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "post",
            data: {
              action: "set_rider_level",
              rider_level: $(this).data("rider-level"),
            },
            error: function (err) {
              console.log(err); //eslint-disable-line
            },
            success: function () {
              location.reload();
            },
          });
        });
    }
    // carousel
    let time = 3000;
    $(".trip-hero").each(function () {
      startCarousel($(this));
    });

    function startCarousel(caller) {
      let to = setTimeout(() => {
        moveCarousel(caller);
      }, time);
      caller.data("timeout", to);
    }

    function moveCarousel(caller) {
      let total = parseInt(caller.attr("data-total"));
      let current = parseInt(caller.attr("data-current"));
      let next = current + 1 > total ? 1 : current + 1;

      caller.find(".trip-hero--item.active").removeClass("active");
      caller.find(`.trip-hero--item--${next}`).addClass("active");
      caller.attr("data-current", next);
      caller.find(".control.active").removeClass("active");
      caller.find(`.control--${next}`).addClass("active");

      startCarousel(caller);
    }

    $(".trip-hero .control").on("click", function () {
      let caller = $(this).parent().parent();
      clearTimeout(caller.data("timeout"));
      caller.attr("data-current", $(this).data("item"));
      moveCarousel(caller);
    });

    $(".box-view__minimize").on("click", function () {
      $(".box-view").toggleClass("minimized");
    });

    $(".climb-row").on("click", function () {
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
      } else {
        $(".climb-row").removeClass("open");
        $(this).addClass("open");
        if (!$(this).hasClass("loaded")) {
          // Load the climb chart
          let climbId = $(this).data("climbid");
          let climbDay = $(this).data("day");
          let level = $(this).data("level");
          getClimbData(climbId, $(this).data("gpx"), function () {
            profileChart(climbId, climbData, climbDay, level);
          });
        }
      }
    });
    $(".climb-detail .tab-btn").on("click", function () {
      if (!$(this).hasClass("active")) {
        $(this)
          .parent()
          .parent()
          .find(".tab-btn, .climb-detail--pane")
          .removeClass("active");
        $(this).addClass("active");
        $(this)
          .parent()
          .next()
          .find(".tab-btn, .climb-detail--pane")
        let $tab = $($(this).data("target"));
        $tab.addClass("active");

        if ($(this).text() === "Map") {
          let climbId = $tab.data("climbid");

          // if (!climbMap[climbId]) {
            initClimbMap(
              $tab.data("climbid"),
              $tab.find(".climb-map")[0],
              climbData[climbId].route,
              climbData[climbId].routeLine
            );
          // }
        }
      }
    });

    $(".box-view .toggle").on("click", function () {
      let viewBox = $(this).attr("data-target");
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $(`.${viewBox}`).removeClass("open");
      } else {
        $(".box-view__cap, .box-view .toggle.open").removeClass("open");
        $(this).addClass("open");
        $(`.${viewBox}`).addClass("open");

        if (
          viewBox === "box-map-view" &&
          !$(`.day-view.active`).hasClass("login-prompt")
        ) {
          // Load the map for the current day //eslint-disable-line
          setDayMapView();
        }
      }
    });

    $('.trip-itinerary--v2 .tbl-rider-levels .rider-level, .trip-detail-itinerary-view--v2 .rider-level').on('click', function() {
      if ( !$(this).hasClass('active') )
      {
        var level = $(this).data('rider-level');
        var btn_target = $('.rider-level[data-rider-level="'+ level +'"]');
        btn_target.addClass('active');
        $('.rider-level').not(btn_target).removeClass('active');
        var target = $('.ride-program-detail tr.pref--' + level + ', .day-view--details--item .pref--' + level);
        var itinerary_url = $('.main--v2 .download-itinerary').attr('href');
        var level_slug = level;

        if ( level == 'companion' )
        {
          $('.download-itinerary--companion').addClass('visible');
          $('.download-itinerary').not('.download-itinerary--companion').removeClass('visible');
        }
        else
        {
          $('.download-itinerary--companion').removeClass('visible');
          $('.download-itinerary').not('.download-itinerary--companion').addClass('visible');
        }

        if ( level_slug != 'companion' )
        {
          if (itinerary_url)
          {
            itinerary_url = itinerary_url.split('rider-level=')[0];
            itinerary_url = itinerary_url + 'rider-level=' + level_slug;
            $('.main--v2 .download-itinerary').not('.download-itinerary--companion').attr('href', itinerary_url);
          }
        }

        $('.climb-view').removeClass('current-pref');
        $('.climb-view.pref--' + level).addClass('current-pref');

        target.addClass('pref-active current-pref');

        $('.pref-active').not(target).removeClass('pref-active');
        var totals_target = $('.itinary_total .totals--' + level );
        totals_target.addClass('active');
        var itinerary_target = $('.itinerary-type--' + level);
        itinerary_target.addClass('active');
        $('.itinerary-type').not(itinerary_target).removeClass('active');
        $('.itinary_total .totals').not(totals_target).removeClass('active');
        var trip_detail_target = $('.trip-detail .day-view--content--' + level);
        trip_detail_target.addClass('active');
        $('.trip-detail .day-view--content').not(trip_detail_target).removeClass('active');
        var trip_carousel_target = $('.trip-detail--carousel--' + level);
        trip_carousel_target.addClass('active');
        $('.main--v2 .trip-detail--carousel').not(trip_carousel_target).removeClass('active');
        if ( level == 'extreme' )
        {
          level = 'epic';
        }
        if ( level == 'companion' )
        {
          $('.ride-program-detail th.distance span, .ride-program-detail th.elevation span').css('opacity', 0);
          $('.itinary_total--averages span').css('opacity', 0);
          $('.main--v2 .trip-detail .box-view').addClass('companion');
        }
        else
        {
          $('.ride-program-detail th.distance span, .ride-program-detail th.elevation span').css('opacity', 1);
          $('.itinary_total--averages span').css('opacity', 1);
          $('.itinary_total--averages .level').text( level[0].toUpperCase() + level.slice(1)).show();
          $('.main--v2 .trip-detail .box-view').removeClass('companion');
        }

        // Refresh map with route for this rider level
        setDayMapView();

      }
    });

    $(".view-toggle").on("click", function () {
      if (!$(this).hasClass("active")) {
        $(".view-toggle,.trip-detail--view").removeClass("active");
        $(this).addClass("active");
        $($(this).data("target")).addClass("active");
        if ($(this).data("target") === ".trip-map-view") {
          if (!tripMap) {
            initTripMap($(".trip-trip-map")[0], [
              $(".trip-detail-wrap").data("map-start-lng"),
              $(".trip-detail-wrap").data("map-start-lat"),
            ]);
            $(".chart-wrapper-day").addClass("loading");
            tripMap.on("load", function () {
              Object.keys(dayData).forEach(function (day) {
                getDayData(
                  day,
                  $(`.day-view--${day} .day-view--content.active`).data("gpx"),

                  function () {
                    let notLoaded = filter(dayData, function (o) {
                      return !o.loaded;
                    }).length;
                    if (notLoaded === 0) {
                      let bbox = false;
                      Object.keys(dayData).forEach(function (loadedDay) {
                        let dr = dayData[loadedDay];
                        if (!bbox && !dr.empty) bbox = dr.route.bbox;
                        else if (!dr.empty) {
                          if (dr.route.bbox.minx < bbox.minx)
                            bbox.minx = dr.route.bbox.minx;
                          if (dr.route.bbox.miny < bbox.miny)
                            bbox.miny = dr.route.bbox.miny;
                          if (dr.route.bbox.maxx > bbox.maxx)
                            bbox.maxx = dr.route.bbox.maxx;
                          if (dr.route.bbox.maxy > bbox.maxy)
                            bbox.maxy = dr.route.bbox.maxy;
                        }
                      });
                      loadTripMap(bbox);
                    }
                  }
                );
              });
            });
          } else {
            tripMap.resize();
          }
        }
      }
    });

    $(".chart-wrapper-day").on("click", function (e) {
      e.preventDefault();
      $(".chart-wrapper-day").removeClass("active");
      $(this).addClass("active");
      let day = $(this).data("day");
      let layer = `route-line-${day}`;
      Object.keys(dayData).forEach(function (day) {
        if (!dayData[day].empty) {
          tripMap.setPaintProperty(`route-line-${day}`, "line-width", 2);
          tripMap.setPaintProperty(
            `route-line-${day}`,
            "line-color",
            "#FF0000"
          );
        }
      });
      tripMap.setPaintProperty(layer, "line-width", 5);
      tripMap.setPaintProperty(`route-line-${day}`, "line-color", "#0032ad");
    });

    // tdf popout
    $(".tdf-stage-view--title").on("click", () => {
      $(".tdf-stage-view").toggleClass("open");
    });

    // detail day changer
    $(".trip-detail--controls div").on("click", function () {
      let id = $(this).attr("data-target");
      let total = parseInt($(".trip-detail-wrap--" + id).attr("data-total"));
      let current = parseInt($(".trip-detail-wrap--" + id).data("current"));
      let next = current;
      if ($(this).hasClass("next"))
        next = current === total ? current : current + 1;
      else next = current === 1 ? current : current - 1;
      changeDetailDay(next, total);
    });

    function changeDetailDay(next, total) {
      $(".trip-detail--controls .disabled").removeClass("disabled");
      if (next === total) {
        $(".trip-detail--controls .next").addClass("disabled");
      }
      if (next === 1) {
        $(".trip-detail--controls .prev").addClass("disabled");
      }
      $(".trip-detail-wrap").data("current", next);
      $(".day-view.active, .trip-detail--carousel__slide.active").removeClass(
        "active"
      );
      $(".trip-detail--track__marker.active").removeClass("active");
      $(
        ".climb-view.active, .stage-view.active, .gravel-view.active"
      ).removeClass("active");

      $(
        `.day-view--${next}, .climb-view--${next}, .gravel-view--${next}, .day-marker-${next}, .stage-view--${next}, #trip-detail--carousel__slide-${next}`
      ).addClass("active");

      $(`.climb-view`).removeClass('current-day');
      $(`.climb-view--${next}`).addClass('current-day');

      // setDayMapView();

      if (!$(".day-view.active .day-view--content.active").data("gpx")) {
        $(".box-view").addClass("disable-tabs");
      } else {
        $(".box-view").removeClass("disable-tabs");
      }

      if ($(`.day-view--${next}`).hasClass("login-prompt")) {
        $(".modal-login").addClass("show");
        $(".box-view .toggle").removeClass("open");
        $(`.${$(".box-view .toggle").attr("data-target")}`).removeClass("open");
      } else if ($(".box-map-view").hasClass("open")) {
        // Load the map for the current day //eslint-disable-line
        setDayMapView();
      }
    }
    // if (!$(".day-view.active").data("gpx")) {
    //   $(".box-view").addClass("disable-tabs");
    // } else {
    //   $(".box-view").removeClass("disable-tabs");
    // }
    $(".trip-detail--track__marker").on("click", function () {
      changeDetailDay($(this).data("target"));
    });

    tippy(".trip-detail--track__marker", { allowHTML: true });

    $(".rvs-toggle-picker").on("click", () => {
      $(".live-race-viewing--stage__title__picker").toggleClass("open");
    });

    $(".itinerary-login").on("click", (e) => {
      e.preventDefault();
      $(".modal-login").addClass("show");
    });

    function setDayMapView() {
      if (!dayMap) {
        initDayMap($(".trip-day-map")[0], [
          $(".trip-detail-wrap").data("map-start-lng"),
          $(".trip-detail-wrap").data("map-start-lat"),
        ]);
      }

      let day = $(".trip-detail-wrap").data("current");
      let gpx = $(`.day-view--${day} .day-view--content.active`).data("gpx");

      getDayData(
        day,
        gpx,
        function (d) {
          loadDayMap(d.route, d.profile, d.routeLine);
        }
      );
    }

    function getDayData(day, gpxId, callback) {

      if (!gpxId) {
        dayData[day] = {
          loaded: true,
          empty: true,
        };
        callback && callback(dayData[day]);
      } else {

        if (!dayData[day] || !dayData[day].loaded || 1 == 1) {
          $.get(`/wp-json/hgr/v1/gpx?id=${gpxId}`, function (data) {
            $(".day-view.active").data("gpx-data", data);
            try {
              JSON.parse(data.geojson);
              var routeLine = JSON.parse(data.geojson);
              let coords = data.route;
              let chartData = [];
              chartData.push({ x: 0, y: coords[0][2] });
              let minZ = 999999;
              let maxZ = 0;
              for (var c = 1; c < coords.length; c++) {
                let newD = calcCrow(
                  coords[c - 1][1],
                  coords[c - 1][0],
                  coords[c][1],
                  coords[c][0]
                );
                chartData.push({
                  x: Math.round((chartData[c - 1].x + newD) * 1000) / 1000,
                  y: coords[c][2],
                  latLng: coords[c],
                });
                if (coords[c][2] < minZ) minZ = coords[c][2];
                if (coords[c][2] > maxZ) maxZ = coords[c][2];
              }

              dayData[day] = {
                route: data,
                profile: chartData,
                routeLine: routeLine,
                coords: coords,
                minZ: minZ,
                maxZ: maxZ,
                loaded: true,
                empty: false,
              };
              callback && callback(dayData[day]);
            } catch (e) {
              dayData[day] = {
                loaded: true,
                empty: true,
              };
              callback && callback(dayData[day]);
            }
          });
        } else {
          callback && callback(dayData[day]);
        }
      }
    }

    function getClimbData(climbId, gpxId, callback) {
      if (!gpxId) {
        climbData[climbId] = {
          empty: true,
        };
        callback(climbData[climbId]);
      } else {
        if (!climbData[climbId]) {
          $.get(`/wp-json/hgr/v1/gpx?id=${gpxId}`, function (data) {
            try {
              JSON.parse(data.geojson);
              var routeLine = JSON.parse(data.geojson);
              let coords = data.route;
              let chartData = [];
              let chartStepData = [];
              chartData.push({ x: 0, y: coords[0][2] });
              chartStepData.push({ x: 0, y: coords[0][2] });
              let minZ = 999999;
              let maxZ = 0;
              let step = 1;
              for (var c = 1; c < coords.length; c++) {
                let newD = calcCrow(
                  coords[c - 1][1],
                  coords[c - 1][0],
                  coords[c][1],
                  coords[c][0]
                );
                if ((chartData[c - 1].x + newD) * 1000 > step * 500) {
                  chartStepData.push({
                    x: step * 500,
                    y: coords[c][2],
                  });
                  step++;
                } else if (c === coords.length - 1) {
                  chartStepData.push({
                    x: Math.round((chartData[c - 1].x + newD) * 1000),
                    y: coords[c][2],
                  });
                }
                chartData.push({
                  x: Math.round((chartData[c - 1].x + newD) * 1000) / 1000,
                  y: coords[c][2],
                });
                if (coords[c][2] < minZ) minZ = coords[c][2];
                if (coords[c][2] > maxZ) maxZ = coords[c][2];
              }

              climbData[climbId] = {
                route: data,
                profileFull: chartData,
                profile: chartStepData,
                routeLine: routeLine,
                coords: coords,
                minZ: minZ,
                maxZ: maxZ,
                loaded: true,
                empty: false,
              };
              callback(climbData[climbId]);
            } catch (e) {
              console.log(e);
              climbData[climbId] = {
                empty: true,
              };
              callback(climbData[climbId]);
            }
          });
        } else {
          callback(climbData[climbId]);
        }
      }
    }

    function initDayMap(el, start) {
      dayMap = new mapboxgl.Map({
        container: el,
        style: "mapbox://styles/thomsonbiketourshgr/ckdrw1tq40dod19o8no9ododv",
        // style: "mapbox://styles/mapbox/standard-beta", // default style
        attributionControl: false,
        zoom: 8,
        center: start,
      })
        .addControl(
          new mapboxgl.AttributionControl({
            compact: true,
          })
        )
        .addControl(new mapboxgl.NavigationControl())
        .addControl(new mapboxgl.FullscreenControl());
      dayMap.scrollZoom.disable();
      dayMap.touchZoomRotate.disableRotation();

      Chart.defaults.LineWithLine = Chart.defaults.line;
      Chart.controllers.LineWithLine = Chart.controllers.line.extend({
        draw: function (ease) {
          Chart.controllers.line.prototype.draw.call(this, ease);

          if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
            var activePoint = this.chart.tooltip._active[0],
              ctx = this.chart.ctx,
              x = activePoint.tooltipPosition().x,
              topY = this.chart.scales["y-axis-0"].top,
              bottomY = this.chart.scales["y-axis-0"].bottom;

            // draw line
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, topY);
            ctx.lineTo(x, bottomY);
            ctx.lineWidth = 1;
            ctx.strokeStyle = "#000";
            ctx.stroke();
            ctx.restore();
          }
        },
      });
    }

    function initTripMap(el, start) {
      tripMap = new mapboxgl.Map({
        container: el,
        style: "mapbox://styles/thomsonbiketourshgr/ckdrw1tq40dod19o8no9ododv",
        //style: "mapbox://styles/thomsonbiketourshgr/ckdtdq13r03tp19quk0ot8xv5",
        attributionControl: false,
        zoom: 8,
        center: start,
      })
        .addControl(
          new mapboxgl.AttributionControl({
            compact: true,
          })
        )
        .addControl(new mapboxgl.NavigationControl())
        .addControl(new mapboxgl.FullscreenControl());
      tripMap.scrollZoom.disable();
      tripMap.touchZoomRotate.disableRotation();
    }

    function initClimbMap(id, el, data, routeLine) {
      let coords = routeLine.features
        ? routeLine.features[0].geometry.coordinates
        : routeLine.geometry.coordinates;

      let climbMapClimb = new mapboxgl.Map({
        container: el,
        style: "mapbox://styles/thomsonbiketourshgr/ckdrw1tq40dod19o8no9ododv",
        attributionControl: false,
        zoom: 10,
        center: coords[0],
      })
        .addControl(
          new mapboxgl.AttributionControl({
            compact: true,
          })
        )
        .addControl(new mapboxgl.NavigationControl())
        .addControl(new mapboxgl.FullscreenControl());
      climbMapClimb.scrollZoom.disable();
      climbMapClimb.touchZoomRotate.disableRotation();
      climbMap[id] = climbMapClimb;
      climbMapClimb.on("load", function () {
        var southWest = new mapboxgl.LngLat(data.bbox.minx, data.bbox.miny);
        var northEast = new mapboxgl.LngLat(data.bbox.maxx, data.bbox.maxy);
        var boundingBox = new mapboxgl.LngLatBounds(southWest, northEast);
        climbMapClimb.addSource("route-climb-" + id, {
          type: "geojson",
          data: routeLine,
        });

        let layer = {
          id: "climb-line-" + id,
          type: "line",
          source: "route-climb-" + id,
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#FF0000",
            "line-width": 3,
          },
        };
        climbMapClimb.addLayer(layer);

        climbMapClimb.fitBounds(boundingBox, {
          padding: 25,
        });

        var ms = $(".map-start-holder")[0].innerHTML;
        var mf = $(".map-finish-holder")[0].innerHTML;
        var elStart = document.createElement("div");
        elStart.className = "map-start";
        elStart.innerHTML = ms;
        var elFinish = document.createElement("div");
        elFinish.className = "map-finish";
        elFinish.innerHTML = mf;
        new mapboxgl.Marker(elStart, { anchor: "bottom" })
          .setLngLat(coords[0])
          .addTo(climbMapClimb);
        new mapboxgl.Marker(elFinish, { anchor: "center" })
          .setLngLat(coords[coords.length - 1])
          .addTo(climbMapClimb);
      });
    }

    function loadDayMap(data, chartData, routeLine) {

      if (!data || !data.bbox) {
        if (dayMap.getSource("route")) {
          removeRoute(dayMap);
        }
        if (chart) {
          chart.data.datasets[0].data = [];
          chart.update();
        }
        return;
      }

      var southWest = new mapboxgl.LngLat(data.bbox.minx, data.bbox.miny);
      var northEast = new mapboxgl.LngLat(data.bbox.maxx, data.bbox.maxy);
      var boundingBox = new mapboxgl.LngLatBounds(southWest, northEast);

      if (dayMap.getSource("route")) {
        for (var i = 0; i < markers.length; i++) {
          markers[i].remove();
        }
        markers = [];
        dayMap.getSource("route").setData(routeLine);
      } else {
        dayMap.once("data", function () {
          
          dayMap.addSource("route", {
            type: "geojson",
            data: routeLine,
          });

          let layer = {
            id: "route-line",
            type: "line",
            source: "route",
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#FF0000",
              "line-width": 3,
            },
          };
          dayMap.addLayer(layer);

          var point = {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                properties: {},
                geometry: {
                  type: "Point",
                  coordinates: data.route[0],
                },
              },
            ],
          };
          dayMap.addSource("point", {
            type: "geojson",
            data: point,
          });

          dayMap.addLayer({
            id: "point",
            source: "point",
            type: "circle",
            paint: {
              "circle-radius": 5,
              "circle-color": "#0032ad",
              "circle-stroke-color": "#0032ad",
              "circle-stroke-width": 1,
              "circle-opacity": 0.9,
            },
          });

          dayMap.fitBounds(boundingBox, {
            padding: 25,
          });
        });
      }
      dayMap.fitBounds(boundingBox, {
        padding: 25,
      });

      let coords = routeLine.features
        ? routeLine.features[0].geometry.coordinates
        : routeLine.geometry.coordinates;
      var ms = $(".map-start-holder")[0].innerHTML;
      var mf = $(".map-finish-holder")[0].innerHTML;
      var elStart = document.createElement("div");
      elStart.className = "map-start";
      elStart.innerHTML = ms;
      var elFinish = document.createElement("div");
      elFinish.className = "map-finish";
      elFinish.innerHTML = mf;
      var marker = new mapboxgl.Marker(elStart, { anchor: "bottom" })
        .setLngLat(coords[0])
        .addTo(dayMap);
      markers.push(marker);
      var marker2 = new mapboxgl.Marker(elFinish, { anchor: "center" })
        .setLngLat(coords[coords.length - 1])
        .addTo(dayMap);
      markers.push(marker2);

      if (chart) {
        chart.data.datasets[0].data = chartData;
        chart.options.scales.xAxes[0].ticks.max =
          chartData[chartData.length - 1].x;
        chart.update();
      } else {
        var bctx = ctx.getContext("2d");
        var background_1 = bctx.createLinearGradient(0, 0, 0, 175);
        background_1.addColorStop(0, "rgba(34, 68, 132, 1)");
        background_1.addColorStop(1, "rgba(34, 68, 132, .4)");
        chart = new Chart(ctx, {
          type: "LineWithLine",
          data: {
            datasets: [
              {
                label: "Elevation",
                data: chartData,
                backgroundColor: background_1,
                borderColor: "rgba(34, 68, 132, 1)",
                pointRadius: 1,
              },
            ],
          },
          options: {
            tooltips: {
              intersect: false,
              mode: "index",
              enabled: false,
              position: "nearest",

              custom: function (tooltipModel) {
                // Tooltip Element
                var tooltipEl = document.getElementById("trip-profile-tooltip");

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 1;

                  if (dayMap.getSource("point")) {

                  dayMap.getSource("point").setData({
                    type: "FeatureCollection",
                    features: [
                      {
                        type: "Feature",
                        properties: {},
                        geometry: {
                          type: "Point",
                          coordinates: chart.data.datasets[0].data[1].latLng,
                        },
                      },
                    ],
                  });

                  }

                  return;
                }

                // Set Text
                if (tooltipModel.body) {
                  var item =
                    chart.data.datasets[0].data[
                      tooltipModel.dataPoints[0].index
                    ];

                    if (dayMap.getSource("point")) {

                    dayMap.getSource("point").setData({
                      type: "FeatureCollection",
                      features: [
                        {
                          type: "Feature",
                          properties: {},
                          geometry: {
                            type: "Point",
                            coordinates: item.latLng,
                          },
                        },
                      ],
                    });

                    }

                  var innerHtml =
                    "<div class='profile-title'>Profile</div><div class='point-data'>";
                  innerHtml +=
                    "<div>⟶| " +
                    Math.round(item.x) +
                    "<span class='unit'>km</span></div>";
                  innerHtml +=
                    "<div>△" +
                    Math.round(item.y) +
                    "<span class='unit'>m</span></div>";
                  innerHtml += "</div>";
                  tooltipEl.innerHTML = innerHtml;
                }

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
              },
            },
            maintainAspectRatio: false,
            animation: {
              duration: 0, // general animation time
            },
            hover: {
              animationDuration: 1, // duration of animations when hovering an item
            },
            responsiveAnimationDuration: 0,
            legend: {
              display: false,
            },
            elements: {
              line: {
                showLine: true,
                spanGaps: true,
                tension: 0, // disables bezier curves
              },
            },
            scales: {
              yAxes: [
                {
                  afterTickToLabelConversion: notFirstY,
                  type: "linear",
                  gridLines: {
                    drawTicks: false,
                    drawBorder: false,
                    z: 1,
                    color: "rgba(200, 200, 200, 0.5)",
                  },
                  ticks: {
                    mirror: true,
                    fontColor: "rgba(100, 100, 100, 0.9)",
                    fontFamily: "Suisse",
                    z: 10,
                    callback: chartElevationLabel,
                  },
                },
              ],
              xAxes: [
                {
                  afterTickToLabelConversion: notFirstOrLast,
                  type: "linear",
                  gridLines: {
                    display: false,
                    drawTicks: false,
                    drawBorder: false,
                  },
                  ticks: {
                    //display: false,
                    stepSize: 1,
                    max: chartData[chartData.length - 1].x,
                    autoSkipPadding: 20,
                    maxRotation: 0,
                    fontColor: "rgba(200, 200, 200, 0.8)",
                    fontFamily: "Suisse",
                    padding: 2,
                    callback: chartDistanceLabel,
                  },
                },
              ],
            },
          },
        });
      }
    }

    function loadTripMap(bbox) {
      var southWest = new mapboxgl.LngLat(bbox.minx, bbox.miny);
      var northEast = new mapboxgl.LngLat(bbox.maxx, bbox.maxy);
      var boundingBox = new mapboxgl.LngLatBounds(southWest, northEast);
      let minZ = 100000;
      let maxZ = 0;
      let start = false;
      let finish = false;
      Object.keys(dayData).forEach(function (day) {
        if (!dayData[day].empty) {
          if (dayData[day].minZ < minZ) minZ = dayData[day].minZ;
          if (dayData[day].maxZ > maxZ) maxZ = dayData[day].maxZ;
        }
      });

      Object.keys(dayData).forEach(function (day) {
        if (!dayData[day].empty && !tripMap.getSource(`route-${day}`)) {
          var routeLine = JSON.parse(dayData[day].route.geojson);
          tripMap.addSource(`route-${day}`, {
            type: "geojson",
            data: routeLine,
          });
          tripMap.addLayer({
            id: `route-line-${day}`,
            type: "line",
            source: `route-${day}`,
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#FF0000",
              "line-width": 2,
            },
          });
          let coords = routeLine.features
            ? routeLine.features[0].geometry.coordinates
            : routeLine.geometry.coordinates;
          if (!start) {
            start = coords[0];
          }
          finish = coords[coords.length - 1];

          let dayCtx = document.getElementById(
            `trip-route-profile-chart-${day}`
          );
          var height = $('.chart-wrapper').height();
          $(dayCtx)
            .width($(dayCtx).data("width") * $(".charts-wrapper").width() - 10)
            .height(height);
          let bctx = dayCtx.getContext("2d");
          let background_1 = bctx.createLinearGradient(0, 0, 0, 175);
          background_1.addColorStop(0, "rgba(34, 68, 132, 1)");
          background_1.addColorStop(1, "rgba(34, 68, 132, .4)");

          new Chart(dayCtx, {
            type: "line",
            data: {
              datasets: [
                {
                  label: "Elevation",
                  data: dayData[day].profile,
                  backgroundColor: background_1,
                  borderColor: "rgba(34, 68, 132, 1)",
                  pointRadius: 1,
                },
              ],
            },
            options: {
              tooltips: {
                intersect: false,
                mode: "index",
                enabled: false,
              },
              responsive: true,
              maintainAspectRatio: false,
              animation: {
                duration: 0, // general animation time
              },
              hover: {
                animationDuration: 0, // duration of animations when hovering an item
              },
              responsiveAnimationDuration: 0,
              legend: {
                display: false,
              },
              elements: {
                line: {
                  showLine: true,
                  spanGaps: true,
                  tension: 1, // disables bezier curves
                },
              },
              scales: {
                yAxes: [
                  {
                    afterTickToLabelConversion: notFirstY,
                    type: "linear",
                    position:
                      $(dayCtx).data("firstlast") === "last" ? "right" : "left",
                    gridLines: {
                      drawTicks: false,
                      drawBorder: false,
                      z: -1,
                      color: "rgba(200, 200, 200, 0.5)",
                    },
                    ticks: {
                      display: true,
                      mirror: true,
                      fontColor: $(dayCtx).data("firstlast")
                        ? "rgba(55, 55, 55, 0.9)"
                        : "rgba(0, 0, 0, 0)",
                      fontFamily: "Suisse",
                      min: Math.round(minZ),
                      max: maxZ,
                      stepSize: 500,
                      // z: 1,
                      beginAtZero: false,
                      callback: chartElevationLabel,
                    },
                  },
                ],
                xAxes: [
                  {
                    type: "linear",
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      display: false,
                      stepSize: 1,
                    },
                  },
                ],
              },
            },
          });
        }
        $(`#chart-wrapper-day-${day}`).removeClass("loading");
      });

      if (start) {
        var ms = $(".map-start-holder")[0].innerHTML;
        var mf = $(".map-finish-holder")[0].innerHTML;
        var elStart = document.createElement("div");
        elStart.className = "map-start";
        elStart.innerHTML = ms;
        var elFinish = document.createElement("div");
        elFinish.className = "map-finish";
        elFinish.innerHTML = mf;
        var marker = new mapboxgl.Marker(elStart)
          .setLngLat(start)
          .addTo(tripMap);
        markers.push(marker);
        var marker2 = new mapboxgl.Marker(elFinish)
          .setLngLat(finish)
          .addTo(tripMap);
        markers.push(marker2);

        tripMap.fitBounds(boundingBox, {
          padding: 50,
        });
      }
    }

    function removeRoute() {
      // dayMap.removeLayer("route-line");
      // //dayMap.removeSource("route");
      // for (var i = 0; i < markers.length; i++) {
      //   markers[i].remove();
      // }
      // markers = [];
    }

    function calcCrow(lat1, lon1, lat2, lon2) {
      var R = 6371; // km
      var dLat = toRad(lat2 - lat1);
      var dLon = toRad(lon2 - lon1);
      lat1 = toRad(lat1);
      lat2 = toRad(lat2);

      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) *
          Math.sin(dLon / 2) *
          Math.cos(lat1) *
          Math.cos(lat2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d;
    }

    // Converts numeric degrees to radians
    function toRad(Value) {
      return (Value * Math.PI) / 180;
    }

    // Waiting List
    $(".toggle-waiting").on("click", function (e) {
      e.preventDefault();
      let dep = $(this).attr("data-dep");
      $("#trip_departure_waiting").val(dep);
      $(".waiting-list--wrap").addClass("open");
    });

    $(".waiting-list--close").on("click", () => {
      $(".waiting-list--wrap").removeClass("open");
    });

    // Gallery
    $(".gallery--next").on("click", () => {
      let current = parseInt($(".gallery--wrap").attr("data-current"));
      let total = parseInt($(".gallery--wrap").attr("data-total"));
      let next = current + 1;
      if (next > total) {
        next = 1;
      }
      change(next);
    });

    $(".gallery--prev").on("click", () => {
      let current = parseInt($(".gallery--wrap").attr("data-current"));
      let total = parseInt($(".gallery--wrap").attr("data-total"));
      let next = current - 1;
      if (next < 1) {
        next = total;
      }
      change(next);
    });

    $(`.gallery--carousel--item`).on("click", function () {
      change($(this).attr("data-item"));
    });

    function change(next) {
      $(".gallery--wrap").attr("data-current", next);
      $(".gallery--carousel--item.active").removeClass("active");
      $(`.gallery--carousel--item--${next}`).addClass("active");
      $(".gallery--item.active").removeClass("active");
      $(`.gallery--item--${next}`).addClass("active");
      $(".gallery--carousel").animate(
        {
          scrollLeft:
            $(`.gallery--carousel--item--${next}`).width() * (next - 1) +
            20 * (next - 1) -
            50,
        },
        500
      );
    }

    $(".ar-view-trip").on("click", () => {
      let top = $(".trip-dates").offset().top;
      $("html, body").animate(
        {
          scrollTop:
            top -
            ($(".trip-nav").height() +
              parseInt($(".trip-nav").css("top"), 10) +
              30),
        },
        500
      );
    });

    $(".ar-close").on("click", () => {
      $(".advanced-res-popup").removeClass("show");
    });

    // Book trip dropdown

    $(".toggle-register").on("click", () => {
      $(".account-login--box").addClass("register");
    });

    $(".toggle-login").on("click", () => {
      $(".account-login--box").removeClass("register");
    });

    $(".btn--login-close").on("click", () => {
      $(".modal-login").removeClass("show");
    });

    // Trip whats included tabs

    $(".trip-whats-included--header").on("click", function () {
      $(this).parent().toggleClass("open");
    });

    // TDF Stage LB

    $(".btn-stage-gallery").on("click", function () {
      let target = $(this).attr("data-target");
      $(target).addClass("open");
      if ($(target).find(".stage-gallery--item").length === 1) {
        $(target).find(".stage-gallery-prev").addClass("disabled");
        $(target).find(".stage-gallery-next").addClass("disabled");
      } else {
        $(target).find(".stage-gallery-next").removeClass("disabled");
      }
      $(target)
        .find("img")
        .each(function () {
          $(this).attr("src", $(this).attr("data-src"));
        });
    });

    $(".stage-gallery-close").on("click", function () {
      $(this).parent().removeClass("open");
    });

    $(".stage-gallery-prev").on("click", function () {
      carouselPrev($(this).parent());
    });

    $(".stage-gallery-next").on("click", function () {
      carouselNext($(this).parent());
    });

    function carouselPrev(target) {
      let track = target.find(".stage-gallery--track");
      let current = parseInt(track.attr("data-current"));
      let total = target.find(".stage-gallery--item").length - 1;
      let next = current == 0 ? 0 : current - 1;
      track.attr("data-current", next);
      track.css({
        transform: `translateX(-${next * 100}vw)`,
      });
      if (next === 0) {
        target.find(".stage-gallery-prev").addClass("disabled");
      } else {
        target.find(".stage-gallery-prev").removeClass("disabled");
      }
      if (total !== next) {
        target.find(".stage-gallery-next").removeClass("disabled");
      }
      // $(`.lightbox-carousel--icon.active`).removeClass("active");
      // $(`.lightbox-carousel--icon--${next}`).addClass("active");
    }

    function carouselNext(target) {
      let track = target.find(".stage-gallery--track");
      let current = parseInt(track.attr("data-current"));
      let total = target.find(".stage-gallery--item").length - 1;
      let next = current == total ? total : current + 1;
      console.log(track, current, total, next); //eslint-disable-line
      track.attr("data-current", next);
      track.css({
        transform: `translateX(-${next * 100}vw)`,
      });
      if (next === 0) {
        target.find(".stage-gallery-prev").addClass("disabled");
      } else {
        target.find(".stage-gallery-prev").removeClass("disabled");
      }
      if (next === total) {
        target.find(".stage-gallery-next").addClass("disabled");
      } else {
        target.find(".stage-gallery-next").removeClass("disabled");
      }
      // $(`.lightbox-carousel--icon.active`).removeClass("active");
      // $(`.lightbox-carousel--icon--${next}`).addClass("active");
    }

    let fullScreenChange;

    if ("onfullscreenchange" in window.document) {
      fullScreenChange = "fullscreenchange";
    } else if ("onmozfullscreenchange" in window.document) {
      fullScreenChange = "mozfullscreenchange";
    } else if ("onwebkitfullscreenchange" in window.document) {
      fullScreenChange = "webkitfullscreenchange";
    } else if ("onmsfullscreenchange" in window.document) {
      fullScreenChange = "MSFullscreenChange";
    }

    function onFullscreenChange() {
      if ($(".charts-wrapper").parent().hasClass("mapboxgl-canvas-container")) {
        $(".charts-wrapper").prependTo($(".trip-map-view"));
        $(".charts-wrapper").width("auto");
      } else if ($(".trip-map-view").hasClass("active")) {
        $(".charts-wrapper").width($(".charts-wrapper").width());
        $(".charts-wrapper").appendTo($(".mapboxgl-canvas-container"));
      }
    }

    window.document.addEventListener(fullScreenChange, onFullscreenChange);

    $("#table-climbs th").on("click", function () {
      $("#table-climbs th").removeClass("sort");
      $(this).addClass("sort");
      if ($(this).hasClass("sort-asc")) {
        $(this).removeClass("sort-asc").addClass("sort-desc");
      } else {
        $(this).removeClass("sort-desc").addClass("sort-asc");
      }
      sortTable("table-climbs", $(this).index(), $(this).hasClass("sort-desc"));
    });

    sortTable(
      "table-climbs",
      $("#table-climbs .sort").index(),
      $("#table-climbs .sort").hasClass("sort-desc")
    );

    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined
            ? true
            : decodeURIComponent(sParameterName[1]);
        }
      }
    };

    let createdAccount = getUrlParameter("recent-create-account")
      ? true
      : false;
    if (createdAccount) {
      setTimeout(() => {
        window.scrollTo(0, $(".trip-detail-wrap").offset().top);
        $(".trip-detail--controls div").each(function () {
          let id = $(this).attr("data-target");
          let total = parseInt(
            $(".trip-detail-wrap--" + id).attr("data-total")
          );
          let next = 4;
          changeDetailDay(next, total);
        });
        MicroModal.show("modal-account-created");
      }, 1000);
    }
    $(".jump-to-mob").on("click", () => {
      $(".jump-to-mob-display").addClass("open");
    });

    $(".jump-to-mob-display-top, .jump-to-mob-display a").on("click", () => {
      $(".jump-to-mob-display").removeClass("open");
    });

    $(".toggle-day-view").on("click", function () {
      let day = $(this).attr("data-day");
      let total = parseInt($(".trip-detail-wrap--0").attr("data-total"));
      changeDetailDay(day, total);
      $(".trip-detail").addClass("show");

      if ($(window).width() > 992) {
        $("html, body").animate(
          {
            scrollTop:
              $(".trip-detail").offset().top -
              ($(".trip-nav").height() +
                parseInt($(".trip-nav").css("top"), 10) +
                30),
          },
          500
        );
      }
    });

    $(".trip-detail--close--action").on("click", function () {
      // let day = $(this).attr("data-day");
      $(".trip-detail").removeClass("show");
    });

    $(".mobile-toggle-date").on("click", function () {
      $(this).parent().toggleClass("open");
    });
  },
};


/* *
 * Visible classes/animations
 * */


$(window).on('load scroll', function() {
  if ($('.main--v2').length)
  {
    $('[data-section]').each(function() {
      if (is_visible($(this)))
      {
        if ( !$(this).hasClass('current') )
        {
          $(this).addClass('current');
          $('[data-section]').not($(this)).removeClass('current');
          var section = $(this).data('section');
          var target = $('.trip-nav--bottom__inner a[href*="'+ section +'"]');
          target.addClass('active');
          $('.trip-nav--bottom__inner [data-target]').not(target).removeClass('active'); 
        }
      }
    });
  }
});



function is_visible(section) {

  var scrollTop = Math.max(0, $(window).scrollTop());

  if (
    scrollTop >= section.offset().top - 100
    &&
    scrollTop <= (section.offset().top + section.outerHeight())
  )
  {
    return true;
  }
  else
  {
    return false;
  }
}


$('.trip-unit--toggle .btn').on('click', function() {
  var unit = $(this).data('unit');
  if ( !$(this).hasClass('active') )
  {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    if ( unit == 'km-m' )
    {
      $('.ride-program-detail td span.km-mile, .day-view--details span.km-mile, .itinary_total .totals span.km').each(function() {
        var km_value = $(this).data('km');
        if ( km_value != '-' )
        {
          km_value = km_value + 'km';
        }
        $(this).text(km_value);
      });

      $('.ride-program-detail td span.m-ft, .day-view--details span.m-ft, .itinary_total .totals span.m-ft').each(function() {
        var m_value = $(this).data('m');
        if ( m_value != '-' )
        {
          m_value = m_value + 'm';
        }
        $(this).text(m_value);
      });

    }
    else
    {
      $('.ride-program-detail td span.km-mile, .day-view--details span.km-mile, .itinary_total .totals span.km').each(function() {
        var mile_value = $(this).data('mile');
        if ( mile_value != '-' )
        {
          mile_value = mile_value + ' miles';
        }
        $(this).text(mile_value);
      });

      $('.ride-program-detail td span.m-ft, .day-view--details span.m-ft, .itinary_total .totals span.m-ft').each(function() {
        var ft_value = $(this).data('ft');
        if ( ft_value != '-' )
        {
          ft_value = ft_value + ' ft';
        }
        $(this).text(ft_value);
      });
    }
  }
});


$('.main--v2 .table-toggle').on('click', function() {
  $(this).parent().siblings('.table-content').slideToggle();
  $(this).toggleClass('open');
  var table = $(this).data('table');
  if ( table == 'compare' )
  {
    $('.table-container--ride-details').toggleClass('compare-closed');
  }
});


$('.detail-toggle').on('click', function() {
  $(this).toggleClass('open');
  $(this).siblings('.read-more-content').slideToggle();
});

$('.trip-hero__container').on('click', function() {
  $(this).siblings('.modal').addClass('visible');
  $('[data-slider="v2-trip"]').slick('setPosition');
});

$('.modal__background, .modal--slider .modal__close').on('click', function() {
  $('.modal--slider').removeClass('visible');
});

$(document).keyup(function(e) {
  if (e.key === "Escape") 
  {
    $('.modal--slider').removeClass('visible');
  }
});


/* *
 * Slick Slider
 * */

$(function() {
  $('[data-slider="v2-trip"]').slick({
    slidesToShow: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    fade: true,
    speed: 500,
    autoplaySpeed: 7000,
    cssEase: 'ease-out',
  });
});

// FAQs toggle

$('.btn--faqs').on('click', function(e) {
  e.preventDefault();
  $(this).parents('.trip-faqs').find('ul').slideToggle();
});

$('.trip-faqs a').on('click', function() {
  $(this).parents('ul').slideToggle();
})


// Hotel upgrades toggle

$('.btn--upgrades').on('click', function(e) {
  e.preventDefault();
  var hotel = $(this).data('hotel');
  var parent = $('.hotel-card[data-hotel="'+ hotel +'"]');
  parent.toggleClass('open');
  var target = $('.hotel-card__upgrades[data-hotel="'+ hotel +'"]');
  if ( !$(target).is(':visible') )
  {
    $(this).text('Close room upgrades');
  }
  else
  {
    $(this).text('View room upgrades');
  }
  target.slideToggle();

});

$('.close-upgrades').on('click', function() {
  var hotel = $(this).data('hotel'); 
  var parent = $('.hotel-card__upgrades[data-hotel="'+ hotel+'"]');
  parent.slideToggle();
  var target = $('.hotel-card[data-hotel="'+ hotel+'"]');
  target.toggleClass('open');
  target.find('.btn--upgrades').text('View room upgrades');
});

/**
 * Splide
 */

document.addEventListener('DOMContentLoaded', function () {

  if ( $('#room-upgrades').length )
  {
    new Splide( '#room-upgrades', {
      type   : 'loop',
      gap: '8px',
      perPage: 3,
      perMove: 1,
      clones: 3,
      arrows: true,
      pagination: false,
      breakpoints: {
        500: {
          perPage: 2,
          fixedWidth: false
        },
      }
    }).mount();
  }   

}); 


$('.table__tabs .table__header').on('click', function() {
  var table = $(this).data('table');
  $(this).css('z-index', 5);
  $('.table__header').not(this).css('z-index', 3);
  var target = $('.table-content[data-table="'+ table +'"]');
  target.css('z-index', 5);
  $('.table-content').not(target).css('z-index', 3);
});


$('.tdf-timeline__info').on('click', function() {
  $('.tdf-timeline__caption').hide();
  $(this).next('.tdf-timeline__caption').show();
});


$('.caption__header .caption__close').on('click', function() {
  $(this).parents('.tdf-timeline__caption').attr('style', '').hide();
});

$(window).on('load', function() {
  if($('.tdf-timeline__row--highlights').length)
  {
    $('.tdf-timeline__column--highlight').first().find('.tdf-timeline__caption').css({'left' : 0, 'transform' : 'translate(0, 50%)'});
    $('.tdf-timeline__column--highlight').last().find('.tdf-timeline__caption').css({'left' : 'auto', 'right' : 0, 'transform' : 'translate(0, 50%)'});
  }
});

$(window).on('load', function() {
  if($('.trip-itinerary').length)
  {
    var windowWidth = $(window).width();

    var days = $('.trip-itinerary').data('days');
    if(windowWidth <= 1025)
    { 
      var max_height = 1160 + (days * 72);
      $('.trip-itinerary').css('max-height', max_height);
    }

    var table_height = $('.table-content').first().innerHeight();
    $('.table-content--compare').innerHeight(table_height);
  }
});






// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js